<article class="business-card" [ngStyle]="backgroundStyle">
  <div class="business-card__grid" *ngIf="showGrid" [ngStyle]="gridStyle" aria-hidden="true"></div>

  <div
    class="business-card__item business-card__text-section"
    *ngFor="let section of textSections; trackBy: trackTextSection"
    [ngStyle]="textSectionStyle(section)"
    (pointerdown)="startDrag($event, section.id)"
    (pointermove)="dragMove.emit($event)"
    (pointerup)="dragStop.emit($event)"
    (pointercancel)="dragStop.emit($event)"
    (click)="editText.emit(section.id)"
  >
    <span [innerHTML]="textSectionHtml(section)"></span>
  </div>

  <div
    class="business-card__item business-card__qr"
    *ngFor="let qrCode of qrCodes"
    [ngStyle]="elementStyle(qrElementId(qrCode))"
    (pointerdown)="startDrag($event, qrElementId(qrCode))"
    (pointermove)="dragMove.emit($event)"
    (pointerup)="dragStop.emit($event)"
    (pointercancel)="dragStop.emit($event)"
  >
    <img [src]="qrImages[qrCode.id]" [alt]="qrCode.title || 'Business card QR code'">
  </div>

  <div
    class="business-card__item business-card__logo"
    *ngFor="let logo of logoSections; trackBy: trackLogoSection"
    [ngStyle]="elementStyle(logo.id)"
    (pointerdown)="startDrag($event, logo.id)"
    (pointermove)="dragMove.emit($event)"
    (pointerup)="dragStop.emit($event)"
    (pointercancel)="dragStop.emit($event)"
  >
    <img [src]="logo.dataUrl" alt="Business card logo">
    <button *ngIf="showLogoRemove" type="button" aria-label="Remove logo" (click)="removeLogo.emit(logo.id)">Remove</button>
  </div>
</article>
